import React from 'react';
import { EditPropertyAddressForm } from './EditPropertyAddressForm';
import { IPropertyAddress } from '../../interfaces/IPropertyAddress';

/** TODO
 * While currently this is all on it's own and used on it's own. In the future this should be rolled into "Edit Single Field" which will get a name change.
 * Basically, the pattern followed in EditSingleField will work out really well for adding the ability to edit properties in it, making having 2 of them redundant.
 */

export interface IEditPropertyAddressControllerProps {
  actions: {
    onClose: () => void;
    doSubmit: (x: IPropertyAddress, y: boolean) => Promise<{ message: string }>;
  };
  propertyAddress: IPropertyAddress;
}

export const EditPropertyAddressController: React.FC<IEditPropertyAddressControllerProps> = ({
  actions: { onClose, doSubmit },
  propertyAddress,
}) => {
  return <EditPropertyAddressForm actions={{ doSubmit, onClose }} propertyAddress={propertyAddress} />;
};
